<template>
	<div class="stage stage--personalia" :style="{ 'background-image': backgroundImage }">
		<div class="personalia-form">
				

				<form style="position: relative;" v-if="stageData.show_teamcode == 'Yes'">
					<div class="text" v-html="stageData.teamcode_text">
						</div>
					<div class="form-section">
						<input class="textfield" type="text" v-model="teamcode" placeholder="Teamcode">
					</div>
				</form>

				<div class="header__container header__container-personalia">
					<div class="header" style="position: relative" v-html="stageData.header">
						<h2>doe je mee?</h2>
					</div> 

					<div class="subHeader" v-html="stageData.subheader">
					</div>

					<div class="text" v-html="stageData.text">
					</div>
				</div>
				<form style="position: relative;">

					<div class="form-section" v-if="stageData.show_groups == 'Yes'">
						<select v-model="selected" style="margin-bottom: 0;" placeholder="Groep">
							<option value="0">
								Groep
							</option>
							<option v-for="(data, i) in globalGroups" :value="data.value" :key="i">
								{{data.name}}
							</option>

						</select>
					</div>

					


					<div class="form-section" v-if="stageData.show_age == 'Yes'">
						<p v-if="language == 'NL'">Leeftijdscategorie</p>
						<p v-else-if="language == 'FR'">l'âge</p>
						<p v-else>Age</p>

						<select v-model="age" style="margin-bottom: 0;" placeholder="Leeftijd">
							<option value="age_1">
								< 20
							</option>
							<option value="age_2">
								20-30
							</option>
							<option value="age_3">
								31-40
							</option>
							<option value="age_4">
								41-50
							</option>
							<option value="age_5">
								51-60
							</option>
							<option value="age_6">
								61+
							</option>

						</select>
					</div>

					<div class="form-section" v-if="stageData.show_gender == 'Yes'">
						<p v-if="language == 'NL'">ik ben een...</p>
						<p v-else-if="language == 'FR'">je suis un...</p>
						<p v-else>I'm</p>


						<div class="radio-border">
							<div class="radio">
								<input type="radio" value="female" v-model="gender">
								<span v-if="language == 'NL'">Vrouw</span>
								<span v-else-if="language == 'FR'">femme</span>
								<span v-else>Female</span>
							</div>
						</div>
						<div class="radio-border">
							<div class="radio">
								<input type="radio" value="male" v-model="gender">
								<span v-if="language == 'NL'">Man</span>
								<span v-else-if="language == 'FR'">homme</span>
								<span v-else>Male</span>
							</div>
						</div>
						<div class="radio-border">
							<div class="radio">
								<input type="radio" value="other" v-model="gender">
								<span v-if="language == 'NL'">Anders</span>
								<span v-else-if="language == 'FR'">autrement</span>
								<span v-else>Other</span>
							</div>
						</div>
					</div>

					<div class="form-section last">
						<p style="margin-bottom: 5px;" v-if="language == 'NL'">Jouw gegevens (optioneel)</p>
						<p style="margin-bottom: 5px;" v-else-if="language == 'FR'">Vos données (facultatif)</p>
						<p style="margin-bottom: 5px;" v-else>Your data (optional)</p>

						<div class="radio">
							<input type="checkbox" v-model="anonymous" checked="checked" style="float: left;">

							<span style="float: left; margin-left: 5px;" v-if="language == 'NL'">Ik speel anoniem</span>
							<span style="float: left; margin-left: 5px;" v-else-if="language == 'FR'">Je joue anonymement</span>
							<span style="float: left; margin-left: 5px;" v-else>I'll stay anonymous</span>
						</div>

						<input class="textfield namefield" type="text" v-model="name" :placeholder="placeHolderName">
						<input class="textfield emailfield" type="text" v-model="email" :placeholder="placeHolderEmail">
					</div>
					<div class="infoHolder">
						<div class="infoHolder__txtBalloon" v-if="language == 'NL'">

							<h3>Belangrijk! Lees deze privacy informatie goed.</h3>

							<h4>Jouw privacy</h4>
							<p>Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.</p>

							<h4>Je speelt standaard anoniem.</h4>
							<p>Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.</p>

							<h4>Koppeling met je e-mailadres en naam</h4>
							<p>Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.</p>

							<p>Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.</p>
							
							<div class="close-btn-holder">
								<i class="fa fa-times" aria-hidden="true"></i>
							</div>
						</div>
						<div class="infoHolder__txtBalloon" v-else-if="language == 'FR'">

							<h3>Belangrijk! Lees deze privacy informatie goed.</h3>

							<h4>Jouw privacy</h4>
							<p>Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.</p>

							<h4>Je speelt standaard anoniem.</h4>
							<p>Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.</p>

							<h4>Koppeling met je e-mailadres en naam</h4>
							<p>Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.</p>

							<p>Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.</p>
							
							<div class="close-btn-holder">
								<i class="fa fa-times" aria-hidden="true"></i>
							</div>
						</div>
						<div class="infoHolder__txtBalloon" v-else>

							<h3>Important! Read this privacy information carefully.</h3>

							<h4>Jouw privacy</h4>
							<p>Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.</p>

							<h4>Je speelt standaard anoniem.</h4>
							<p>Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.</p>

							<h4>Koppeling met je e-mailadres en naam</h4>
							<p>Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.</p>

							<p>Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.</p>
							
							<div class="close-btn-holder">
								<i class="fa fa-times" aria-hidden="true"></i>
							</div>
						</div>


						<div class="infoHolder__info-btn">
							<span>i</span>
						</div>	
					</div>
				</form>
			</div>
		</div>
	</div>

</template>

<script>

	

	import Vue from 'vue';
	import { mapGetters , mapActions } from 'vuex';
	import { url} from '../../const/base';
	import { api_url} from '../../const/base';
	import { lang } from '../../const/base';

	export default {


		data(){
			return{
				baseUrl : url,
				apiUrl : api_url,
				language: lang,
				headerReady: true,
				visualReady: true,
				storyReady: true,
				anonymous: true,
				name: '',
				surname: '',
				email: '',
				teamcode: '',
				selected: 0,
				gender: false,
				age: false,
				answers: [],
				placeHolderName: 'Naam',
				placeHolderEmail: 'E-mailadres',
				disabled_input: '',
			}
		},

		beforeMount(){
			if(this.language == 'FR'){
				this.placeHolderName = 'Nom';
				this.placeHolderEmail = 'Adresse e-mail';
			}else if(this.language == 'EN'){
				this.placeHolderName = 'Name';
				this.placeHolderEmail = 'E-mailaddress';
			}
		},

		mounted(){

			this.showTransitorScore(false);

			if(this.teamCode){
				this.teamcode = this.teamCode;
			}

			//console.log(this.teamcode);

			if(typeof this.respondent !== 'undefined'){

				if(this.respondent !== 'false'){

					console.log('setting personal data');
						
					this.name = this.respondent.first_name;

					if(this.respondent.surname_prefix != ''){
						this.name = this.name + ' ' + this.respondent.surname_prefix;
					}

					if(this.respondent.surname != ''){
						this.name = this.name + ' ' + this.respondent.surname;
					}



					if(this.respondent.email != ''){
						this.email = this.respondent.email;
					}


					//find correct group
					
					for(let i = 0 ; i < this.globalGroups.length ; i++){
						if(this.respondent.company_group == this.globalGroups[i].value){
							this.selected = this.globalGroups[i].value;
							break;
						}
					}
				}
			}



			if(this.lastStage){
				// this.setNextButtonAction(this.stopBlockTransition).then(()=>{
				// 	this.showNextButton();
				// });
				this.setNextButtonAction(this.setAnsers);
			}
			else{
				this.setNextButtonAction(this.toNextStage).then(()=>{
					this.showNextButton();
				});
			}

			this.validate();

			$(document).ready(function(e) {
			    $(".infoHolder__info-btn").click(function(event) {
			        $(".infoHolder__txtBalloon").toggleClass("active");
			        event.stopPropagation();
			    });


			    $(document).click(function(event){
			        if (!$(event.target).hasClass('link')) {
			            $(".infoHolder__txtBalloon").removeClass("active");
			        }
			    });


			    $(".close-btn-holder").click(function(event){
			        if (!$(event.target).hasClass('link')) {
			            $(".infoHolder__txtBalloon").removeClass("active");
			        }
			    });
			});



		},

		methods:{
			...mapActions([
				"showNextButton",
				"hideNextButton",
				"setNextButtonAction",
				"toNextStage",
				"stopBlockTransition",
				"showTransitorScore",
				"playAudio",
				"setTeamCode",
			]),

			triggerPopup() {

				
				//console.log(this.anonymous);
				if(!this.anonymous){
					$(".infoHolder__txtBalloon").toggleClass("active");
				}
			},

			validate() {

				let isValidated = true;

				//console.log(this.selected);

				if(this.selected === 0 && this.stageData.show_groups == "Yes"){
					isValidated = false;
				}

				if(!this.gender && this.stageData.show_gender == "Yes"){
					isValidated = false;
				}

				if(!this.age && this.stageData.show_age == "Yes"){
					isValidated = false;
				}

				

				//console.log(this.anonymous);
				if(!this.anonymous){

					if(!this.name){
						isValidated = false;
					}
					if(!this.email){
						isValidated = false;
					}

				}


				if(isValidated){
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":false, "btn-static":true});
				}else{
					this.hideNextButton();
				}

				if(this.anonymous){

					//disable input fields
					$(".namefield").attr("disabled", true);
					$(".emailfield").attr("disabled", true);

					this.name = '';
					this.email = '';
				}else{

					$(".namefield").attr("disabled", false);
					$(".emailfield").attr("disabled", false);
				}


		    	return isValidated;
		    },

			setAnsers(){

                console.log('challenges_session_token: '+ this.challengeToken);



				let sendObj = {
					"user_id": this.userId,
					"instance_id" : this.instanceId,
					"group" : this.selected,
					"teamcode" : this.teamcode,
					"gender" : this.gender,
					"age" : this.age,
					"name" : this.name,
					"surname" : this.surname,
					"email" : this.email,
					"challenges_session_token": this.challengeToken
				};

				//console.log("sendObj");
				//console.log(sendObj);

				Vue.http.post(this.apiUrl + 'api/v2/savepersonaldata' , sendObj).then(response => {
					//console.log(response.status);
					//console.log(response.statusText);
					//console.log(response.body);
				}).catch(response => {
					//console.log("Error: ");
					//console.log(response);
				});

				//this.$socket.emit('finished challenge', sendObj);

				this.setTeamCode(this.teamcode);

				// var data = {'instance_id': this.instanceId, 'client_id':this.userId, 'teamcode':this.teamcode};
    //             this.$socket.emit('join_instance', data);


                //store answers then:
				this.stopBlockTransition();

			},
		},

		watch: {
		    // whenever question changes, this function will run
		    selected: function (newVar, oldVar) {
		      this.validate()
		    },
		    gender: function (newVar, oldVar) {
		      this.validate()
		    },
		    age: function (newVar, oldVar) {
		      this.validate()
		    },
		    anonymous: function (newVar, oldVar) {
		      this.validate();
		      this.triggerPopup();
		    },
		    name: function (newVar, oldVar) {
		      this.validate()
		    },
		    email: function (newVar, oldVar) {
		      this.validate()
		    }
		},

		computed: {

			backgroundImage: function() {

				if(typeof this.stageData.background === 'undefined' || this.stageData.background === null){ 
					return 'none';
				}

		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },

			// validated: function () {

			// 	let isValidated = true;

			// 	console.log(this.selected);

			// 	if(this.selected === 0){
			// 		isValidated = false;
			// 	}



			// 	if(isValidated){
			// 		this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":false, "btn-static":true});
			// 	}

		 //    	return isValidated;
		 //    },

			...mapGetters([
				"stageData",
				"lastStage",
				"blocks",
				"scores",
				"lastBlock",
				"globalGroups",
				"instanceId",
				"userId",
				"teamCode",
				"respondent",
				"challengeToken",
				"instanceId",
				"userId",
			]),
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/personalia/Index.vue